export default __webpack_public_path__ + "static/media/P16.aff28d06.png";